export const Availability = {
    NEW_AVAILABILITY_LIST: "availability.new.list",
    SET_SELECTED_AVAILABILITY: "availability.set_selected",
    DELETE_AVAILABILITY_LIST: "availability.delete.list",
    UPDATE_AVAILABILITY_LIST: "availability.update.list",
    PREPARE_TAKE: "availability.prepare_take",
    PREPARE_NEEDS: "availability.prepare_needs",
    RESET_TAKE: "availability.reset_take",
    UPDATE_REQUEST_ROWS: "availability.update_request_rows",
    DELETE_REQUEST_ROW: "availability.delete_request_row",
    ATTACH_MARKET_DATA: "availability.attach_market_data",
    APPLY_REF_RATE: "availability.apply_ref_rate",
    APPLY_MATURITY: "availability.apply_maturity",
    AVAILABILITY_SET_NEEDS: "availability.set_needs",
};
